import { observer } from 'mobx-react-lite'
import { Alert } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const AlertAddCredits = observer(() => {
  const { remindersStore } = useEntitiesContext()
  const { creditsStore } = remindersStore

  if (!creditsStore.show) return null
  if (!creditsStore.canManageCredits) {
    return (
      <Alert
        item={{
          type: 'warning',
          title: 'Your organization is out of message credits.',
          desc: 'Ask one of your admins to upgrade or enable auto-recharge.',
        }}
      />
    )
  }

  return (
    <Alert
      item={{
        type: 'warning',
        title: 'Your organization is out of credits.',
        desc: 'Upgrade or enable auto-recharge to keep sending and receiving messages.',
      }}
      actions={[
        {
          variant: 'button',
          type: 'primary',
          text: 'Upgrade plan',
          onClick: () => {
            creditsStore.navigateToUpgrade()
          },
        },
        {
          variant: 'button',
          type: 'secondary',
          text: 'Enable auto-recharge',
          onClick: () => {
            creditsStore.autoRechargeWidgetStore.openModal()
          },
        },
      ]}
    />
  )
})
